import { makeAsyncComponent } from '../../utils/makeAsyncUtils';
export default makeAsyncComponent(() => import('./ClonePageModal' /* webpackChunkName: "chunk-clone-page-modal" */), {
  showLoading: false
});